module.exports = __webpack_public_path__ + "532846eff36d1cf2ee614946c0b4d861.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-princess-s.png
// module id = 1914
// module chunks = 0